import React from "react";
import { Box, Container } from "@mui/material";
import { LayoutProps } from "../types";
import Footer from "./Footer";
import Header from "./Header";
import Background from "./../assets/images/Background.svg";

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      {/* Background Image */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${Background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: -2, // Keep it below everything
        }}
      />

      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.04, // Set video opacity to 4%
          zIndex: -1, // Keep it above the background image
        }}
      >
        <source src={`${process.env.PUBLIC_URL}/background.mp4`} type="video/mp4" />
      </video>

      {/* Content with Transparent Overlay */}
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          backgroundColor: "transparent",
          backdropFilter: "blur(5px)", // Optional blur effect
          color: "white",
        }}
      >
        <Container maxWidth="lg">
          <Header />
          <Box>{children}</Box>
        </Container>
        <Footer />
      </Box>
    </>
  );
};

export default Layout;
